import { t } from 'i18next';
import { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';

import uploadIcon from '../../../assets/img/icons/upload.svg';
import {
  CommonFlex,
  CommonGrid,
  CommonImage,
  CommonText,
} from '../../../styledComponents/common';
import { CheckListNameInputField } from '../../../styledComponents/tasks';
import {
  DropZoneContainer,
  UpdateImageHoverDiv,
  UploadImageDiv,
} from '../../UserProfile/profileStyles';
import { ZoneButton } from '../officesStyles';

const dropZoneCss = {
  width: '100%',
  height: '150px',
  objectFit: 'cover',
  objectPosition: 'center',
  background: '#FFFFFF',
  border: '2px dotted #A2845E',
  borderRadius: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
const dropZoneCssNoBorder = {
  width: '100%',
  height: '150px',
  objectFit: 'cover',
  objectPosition: 'center',
  background: '#FFFFFF',
  border: '2px dotted #A2845E',
  borderRadius: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const PdfUpload = ({ setFiles, columns, files }) => {
  const [filesState, setFilesState] = useState([]);

  const onDrop = acceptedFiles => {
    const newFiles = acceptedFiles.map(file => ({
      file,
      name: file.name,
      preview: URL.createObjectURL(file),
      description: '',
    }));
    const updatedFiles = [...filesState, ...newFiles];
    setFilesState(updatedFiles);
    setFiles(updatedFiles);
  };

  const handleDescriptionChange = (index, value) => {
    const updatedFiles = [...filesState];
    updatedFiles[index].description = value;
    setFilesState(updatedFiles);
    setFiles(updatedFiles);
  };

  const removeFile = index => {
    const updatedFiles = filesState.filter((_, i) => i !== index);
    setFilesState(updatedFiles);
    setFiles(updatedFiles);
  };

  useEffect(() => {
    if (files) {
      setFilesState(files);
    }
  }, [files]);

  return (
    <div>
      <DropZoneContainer>
        <CommonGrid columns={columns || '1fr'}>
          <Dropzone
            style={
              filesState.base64 || files ? dropZoneCssNoBorder : dropZoneCss
            }
            onDrop={onDrop}
            accept="application/pdf"
            multiple
          >
            {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => (
              <div
                style={
                  filesState.length > 0 ? dropZoneCssNoBorder : dropZoneCss
                }
              >
                <input type="file" style={{ display: 'none' }} />
                <UploadImageDiv
                  height="50px"
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <CommonImage src={uploadIcon} alt="Upload" size="24px" />
                  <CommonText fontSize="14px" margin="0">
                    {t('click_or_drop_here_to_upload')}
                  </CommonText>
                  <CommonText fontSize="12px" margin="0">
                    {t('max_10_md_files_are_allowed')}
                  </CommonText>
                </UploadImageDiv>
              </div>
            )}
          </Dropzone>
        </CommonGrid>
      </DropZoneContainer>
      <CommonGrid columns="repeat(auto-fill, minmax(500px, 1fr))" gap="20px">
        {filesState.map((file, index) => (
          <CommonFlex
            key={index}
            style={{
              marginTop: '10px',
              padding: '10px',
              backgroundColor: '#E0BFB81F',
              borderRadius: '6px',
            }}
            direction="column"
          >
            <CommonFlex
              justifyContent="space-between"
              alignItems="center"
              gap="20px"
              width="100%"
            >
              <CommonText fontSize="14px" fontWeight="bold" active>
                {file.name}
              </CommonText>
              <ZoneButton
                fontWeight="600"
                onClick={() => removeFile(index)}
                bgColor="#E0BFB8"
              >
                Remove
              </ZoneButton>
            </CommonFlex>
            <iframe
              src={file.preview}
              title={`PDF Preview ${index}`}
              style={{ width: '100%', height: '350px', marginTop: '5px' }}
            />
            <CheckListNameInputField
              type="text"
              placeholder={`${t('enter_a_description_for_your_file')}...`}
              value={file.description}
              onChange={e => handleDescriptionChange(index, e.target.value)} // Uncommented this line
              bgColor="#E0BFB899"
            />
          </CommonFlex>
        ))}
      </CommonGrid>
    </div>
  );
};

export default PdfUpload;
